import { Modal } from "antd";

import { useEffect, useState } from "react";
import "styles/googleLocationModal.scss";
import { CoordAddress } from "components/Map/GoogleMapAutoComplete";
import { GoogleMaps } from "components/Map/GoogleMaps";

export const GoogleLocationModal = ({
  coord,
  visible,
  onClose,
  onSubmitOk,
}: {
  visible?: boolean;
  onClose: () => void;
  onSubmitOk: (addressInfo: CoordAddress) => void;
  coord: CoordAddress;
}) => {
  const [loading, setLoading] = useState(false);
  const [addressInfo, setAddressInfo] = useState<CoordAddress>();
  const [originAddress, setOriginAddress] = useState<string | undefined>("");

  const handleSubmitForm = async () => {
    if (addressInfo) {
      onSubmitOk(addressInfo);
      onClose();
    }
  };

  useEffect(() => {
    if (coord.lat) {
      setOriginAddress(coord.address);
      setAddressInfo({
        address: coord.address,
        lat: coord.lat,
        lng: coord.lng,
        placeId: coord.placeId,
      });
    }
  }, [coord]);

  return (
    <Modal
      className="address-modal"
      onCancel={onClose}
      open={visible}
      title={"Chọn địa chỉ"}
      confirmLoading={loading}
      onOk={handleSubmitForm}
      width={720}
      centered
      okText={"Lưu"}
      okButtonProps={{
        disabled: !addressInfo,
      }}
      cancelText={"Đóng"}
      destroyOnClose
    >
      <GoogleMaps
        center={
          coord.lat
            ? { lat: coord.lat, lng: coord.lng }
            : undefined
        }
        onPlaceSelected={(address) => {
          setAddressInfo(address);
        }}
      />
    </Modal>
  );
};
